import axios from "../lib/api.request";

import QueryResourceParams from './models/queryResourceParams'

// 获取资源列表
export const getResourceCategoryList = (url?) => {
    return axios.request({
        url: url || '/leco/ecology/api/v1/categoryMgr/info/getCategoryTreeNode',
        method: 'get',
        noLoading: true
    })
} 
// 查询资源
export const queryResource = (params:QueryResourceParams, url?) => {
    return axios.request({
        url: url||"/leco/ecology/api/v1/teacher/resource/list",
        method: "post",
        noLoading : true,
        data:params
    });
}